import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDocument(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M8 13C8 12.4477 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H9C8.44772 14 8 13.5523 8 13Z"
        fill="currentColor"
      />
      <path
        d="M9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18H12C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16H9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2L6 2C4.9 2 4 2.9 4 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579ZM18 20H6L6 4L14 4V7C14 7.55228 14.4477 8 15 8H18V20Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
